import { NavLink, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/servizi", label: "Servizi" },
  { to: "/blog", label: "L'esperto risponde" },
  { to: "/contatti", label: "Contatti" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#050505]/90 backdrop-blur-md border-b border-[#1a1a1a]"
          : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <Logo size="sm" dataTestId="navbar-logo" />

        <nav className="hidden md:flex items-center gap-8" aria-label="Navigazione principale">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors hover:text-[#FACC15] ${
                  isActive ? "text-[#FACC15]" : "text-white/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contatti"
            data-testid="navbar-cta"
            className="btn-yellow text-sm"
            style={{ padding: "10px 18px" }}
          >
            Richiedi una consulenza
          </Link>
        </nav>

        <button
          className="md:hidden text-white p-3 -mr-3"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Chiudi menu" : "Apri menu"}
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#1a1a1a] bg-[#050505]" data-testid="mobile-menu">
          <div className="px-6 py-3 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-base py-3 ${isActive ? "text-[#FACC15]" : "text-white/85"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contatti"
              onClick={() => setOpen(false)}
              className="btn-yellow text-sm w-full text-center mt-3"
              data-testid="mobile-cta"
            >
              Richiedi una consulenza
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
